export const DEFAULT_GRID_AUTOSIZE_OPTIONS = {
  includeHeaders: true,
  includeHeaderFilters: false,
  includeOutliers: false,
  outliersFactor: 1.5,
  expand: false,
  disableColumnVirtualization: true
};

/**
 * The Resize API interface that is available in the grid `apiRef`.
 */